<template>
  <div class="mt-32">
    <div v-if="isSubmitted" class="flex flex-col items-center text-center text-gray-900">
      <span :class="`text-3xl text-${style.accent}`">Success!</span>
      <span>Your review has been submitted.</span>
      <span>Your feedback is valuable to us and will be reviewed shortly. Thank you for your time!</span>
    </div>
    <div v-else style="color: white;">
      <div :class="[style.title, 'normal-case']">Rate Us Out Of 5</div>
      <div class="flex -ml-3 mt-4">
        <div class="grade-card grade-card--big">
          <div
            :class="[`content bg-${style.bg}`, grade === 1 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="grade = 1"
          >
            <div class="title">1</div>
            <div class="subtitle">VERY POOR</div>
          </div>
        </div>
        <div class="grade-card grade-card--big">
          <div
            :class="[`content bg-${style.bg}`, grade === 2 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="grade = 2"
          >
            <div class="title">2</div>
            <div class="subtitle">POOR</div>
          </div>
        </div>
        <div class="grade-card grade-card--big">
          <div
            :class="[`content bg-${style.bg}`, grade === 3 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="grade = 3"
          >
            <div class="title">3</div>
            <div class="subtitle">NORMAL</div>
          </div>
        </div>
        <div class="grade-card grade-card--big">
          <div
            :class="[`content bg-${style.bg}`, grade === 4 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="grade = 4"
          >
            <div class="title">4</div>
            <div class="subtitle">GOOD</div>
          </div>
        </div>
        <div class="grade-card grade-card--big">
          <div
            :class="[`content bg-${style.bg}`, grade === 5 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="grade = 5"
          >
            <div class="title">5</div>
            <div class="subtitle">VERY GOOD</div>
          </div>
        </div>
      </div>

      <div
        :class="`font-bold font-lato text-${style.accent} mt-10`"
      >How likely is it that you would recommend Unranked smurfs to a friend or colleague?</div>
      <div class="flex -ml-3 mt-4">
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 1 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 1"
          >1</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 2 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 2"
          >2</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 3 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 3"
          >3</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 4 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 4"
          >4</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 5 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 5"
          >5</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 6 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 6"
          >6</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 7 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 7"
          >7</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 8 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 8"
          >8</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 9 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 9"
          >9</div>
        </div>
        <div class="grade-card grade-card--small">
          <div
            :class="[`content bg-${style.bg}`, recommendation === 10 ? `text-${style.accent} border-${style.accent}` : 'border-transparent']"
            @click="recommendation = 10"
          >10</div>
        </div>
      </div>

      <div :class="[style.title, 'normal-case mt-10']">Write A Quick Review</div>
      <textarea rows="10" class="mt-4 rounded w-full p-2" v-model="comment"></textarea>

      <div class="flex justify-center mt-6">
        <button
          :class="['btn cursor-pointer', style.btn, !canSubmit && 'btn-disabled']"
          :disabled="!canSubmit"
          @click="submit()"
        >Submit Your Review</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mode: String,
  },

  data() {
    return {
      grade: null,
      recommendation: null,
      comment: '',
      isSubmitted: false,
    };
  },

  methods: {
    submit() {
      this.isSubmitted = true;
    },
  },

  computed: {
    canSubmit() {
      return (
        this.grade !== null &&
        this.recommendation !== null &&
        this.comment !== ''
      );
    },

    style() {
      return this.mode === 'unrankedsmurfs'
        ? {
            accent: 'smurfs-gold',
            btn: 'btn-gold',
            bg: 'smog-grey',
            title: 'heading-3 heading-gold',
          }
        : {
            accent: 'blue',
            btn: 'btn-orange',
            bg: 'grey',
            title: 'text-3xl text-blue-600',
          };
    },
  },
};
</script>

<style lang="scss" scoped>
.review-form {
  color: white;
}

.grade-card {
  .content {
    @apply flex flex-col;
    @apply border-2 rounded-lg;
    @apply text-center;
    @apply px-3 py-2;
    @apply cursor-pointer select-none;
  }
}

.grade-card--big {
  @apply w-1/5 pl-3;

  .content {
    .title {
      font-size: 60px;
      line-height: 70px;
    }

    .subtitle {
      font-size: 18px;
    }
  }
}

.grade-card--small {
  @apply pl-3;
  width: 10%;
  font-size: 25px;
}
</style>
